var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1407_12352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5984 38.124V21.6C39.5984 19.62 37.9784 18 35.9984 18C34.0184 18 32.3984 19.62 32.3984 21.6V39.6C32.3984 40.068 32.5064 40.536 32.6864 40.968C32.8664 41.4 33.1184 41.796 33.4784 42.156L40.6784 49.356C41.3984 50.076 42.2984 50.4 43.2344 50.4C44.1704 50.4 45.0704 50.04 45.7904 49.356C47.1944 47.952 47.1944 45.684 45.7904 44.28L39.6344 38.124H39.5984Z",
    fill: "#ED8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0C16.164 0 0 16.164 0 36C0 55.836 16.164 72 36 72C55.836 72 72 55.836 72 36C72 16.164 55.836 0 36 0ZM36 64.8C20.124 64.8 7.2 51.876 7.2 36C7.2 20.124 20.124 7.2 36 7.2C51.876 7.2 64.8 20.124 64.8 36C64.8 51.876 51.876 64.8 36 64.8Z",
    fill: "#ED8E3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1407_12352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.e12d438c.svg";
export { ForwardRef as ReactComponent };